<template>
 <div :class="windowClass">
   <v-container>
    <v-row>
      <v-col cols="12">
                <v-card>
               <v-toolbar>
                 <v-icon left color="primary">mdi-swap-horizontal-bold</v-icon> Wallet Transactions
                 <v-spacer/>
                 <span style="width: 290px;">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            dense
                            outlined
                            hide-details
                        ></v-text-field>
                 </span>
                 <v-divider vertical inset class="ml-5 mr-2"/>
                        <v-btn text small color="success" v-if="ALLOW('load_transfer')"  @click="selecteditem={}, state='new', form=true"><v-icon small left color="success">mdi-plus</v-icon>  Transfer</v-btn>
               </v-toolbar>
               <v-card-text>
                <v-data-table
                    class="va-table"
                    dense
                    :headers="headers"
                    :search="search"
                    disable-sort
                    :items="items"
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                    
                             <td>{{ $moment(item.created_dt).format("MMM, DD YYYY hh:mm A") }}</td>
                            <td>{{ item.transaction.type }}
                                <template v-if="item.action =='Transfer'">
                                    to {{item.transaction.to_account_name}}
                                </template>   
                            </td>
                             <td :class="STATUS_COLOR(item.status)">{{ item.transaction.status }}</td>
                              <th class="text-right" :class="item.action =='Load'?'text-success':'text-error'">{{item.action =='Load'?'+':'-'}} {{ $money(item.transaction.amount) }}</th>
                              <td class="text-right" >{{ $money(item.wallet) }}</td>
                        </tr>
                        </tbody>
                    </template>
                    </v-data-table>
               </v-card-text>
             </v-card>
          </v-col>
         
    </v-row>
    </v-container>
     <va-transfer-form :show="form" :state="state" @DialogEvent="formEvent" />
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        search:"",
        selectedID:  null,
        trans_dailog: false,
        areaform: false,
        state: 'new',
        items:[],
        headers: [
            { text: 'Date', value:"created_dt"},
            { text: 'Type', value:"type"},
            { text: 'Status', value:"status"},
            { text: 'Amount', value: "amount", align: "right" },
             { text: 'Updating', value: "wallet", align: "right" }
        ]
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getItems()
        // this.GET_FRANCHISEE()
          this.GET_BRANCHES()
          // this.CHECK_IF_FRANCHISEE()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
    
      formEvent(){
          this.form = false
          this.getItems()
          //this.CHECK_IF_FRANCHISEE()
      },

      getItems: function() { 
        this.$http.get("wallet/transactions").then(response => {
          console.log(response.data.list)
            response.data.list != null?this.items = response.data.list:this.items =[]
        }).catch(e => {
        console.log(e.data)
        })
     }
    }
  }
</script>